import { combineReducers } from "redux";
import {
  settingsReducer,
  weixinOauthReducer,
  userReducer,
  patientReducer,
} from "./system";

export default combineReducers({
  settings: settingsReducer,
  weixinOauth: weixinOauthReducer,
  user: userReducer,
  patient: patientReducer,
});
